import { render, staticRenderFns } from "./EditBar.vue?vue&type=template&id=227cbc99&scoped=true"
import script from "./EditBar.vue?vue&type=script&lang=js"
export * from "./EditBar.vue?vue&type=script&lang=js"
import style0 from "./EditBar.vue?vue&type=style&index=0&id=227cbc99&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227cbc99",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('227cbc99')) {
      api.createRecord('227cbc99', component.options)
    } else {
      api.reload('227cbc99', component.options)
    }
    module.hot.accept("./EditBar.vue?vue&type=template&id=227cbc99&scoped=true", function () {
      api.rerender('227cbc99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/components/editor/EditBar.vue"
export default component.exports